import React, { useRef } from 'react';
import {
    FlyoutDirection,
    FlyoutMenuButton,
    FlyoutMenuTheme,
} from '@apply/components';
import { FlyoutMenuButtonBorderRadius } from '@apply/components/src/components/controls/FlyoutMenuButtons/FlyoutMenuButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

export interface ActionsMenuItem {
    label: string;
    onClick: () => void;
    destructive?: boolean;
}

interface ActionsMenuProps {
    id: string;
    items: ActionsMenuItem[];
}

export const ActionsMenu: React.FC<ActionsMenuProps> = ({ id, items }) => {
    const menuRef = useRef<HTMLDivElement>(null);

    const closeMenu = () => {
        const details = menuRef.current?.querySelector('details');
        if (details) {
            details.open = false;
        }
    };

    const buttonContent = (
        <div style={{ display: 'flex' }}>
            <div style={{ paddingRight: '10px' }}>Actions</div>
            <div>
                <FontAwesomeIcon icon={faCaretDown} />
            </div>
        </div>
    );

    return (
        <div ref={menuRef}>
            <FlyoutMenuButton
                id={id}
                direction={FlyoutDirection.Left}
                theme={FlyoutMenuTheme.DarkBlueActive}
                borderRadius={FlyoutMenuButtonBorderRadius.Small}
                buttonContent={buttonContent}
                width='110px'
                height='38px'
            >
                <ul style={{ textAlign: 'left', display: 'grid', gap: '15px' }}>
                    {items.map((item) => (
                        <li key={item.label}>
                            <a
                                className={item.destructive ? 'bp-actionsMenu__destructive' : undefined}
                                onClick={() => {
                                    closeMenu();
                                    item.onClick();
                                }}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </FlyoutMenuButton>
        </div>
    );
};
